import * as yup from 'yup';

export const ocrCreditAddSchema = yup.object().shape({
  ocrCredit: yup
    .number()
    .typeError('数字を入力してください')
    .required('OCRクレジットを入力してください')
    .integer('OCRクレジットは整数で入力してください')
    .min(1, 'OCRクレジットは1〜300,000の範囲で入力してください')
    .max(300000, 'OCRクレジットは1〜300,000の範囲で入力してください'),
  note: yup
    .string()
    .required('備考を入力してください')
    .max(2000, '備考は2,000文字以内で入力してください'),
});
